module.exports = __webpack_public_path__ + "img/微信图标.42519776.png";